import { useTranslation } from 'react-i18next'

const DadAfter = (props) => {
  const { t } = useTranslation()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="dad-end-title"
      {...props}
    >
      <title id="dad-end-title">{t('antagonists:dad:components:end')}</title>
      <path
        d="m1778.31 812.44-242.74-11.48s-20.67 41.36-34.46 111.04c-13.77 69.68-22.79 194.1-22.79 246.18 0 52.08-12.45 110.68-11.69 188.03s25.27 175.23 25.27 175.23l73.53-4.39s-.02-69.13 5.34-129.62-9.78-116.66 1.7-150.36c11.48-33.7 73.71-209.26 73.71-209.26s13.68 126.38 16.75 167.72c3.07 41.34-8.48 101.68-6.19 152.22 2.29 50.54-2.01 174.61-2.01 174.61l74.14 2.74s20.52-76.27 28.94-130.64c8.43-54.37 3.83-151.61 3.83-179.18 0-27.57 35.05-183.8 33.52-238.93s-16.84-163.87-16.84-163.87l-.02-.03Z"
        style={{
          fill: '#4b6c52',
        }}
      />
      <path
        d="m1708 360.44-99.34-1.11s3.66 55.31-.21 68c-3.87 12.69-47.99 32.99-47.99 32.99l-11.43 45.26 216.33.55 10.39-48.82s-55.74-26.05-62.36-35.99c-6.62-9.94-5.41-60.89-5.41-60.89h.02Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="M1692.86 203.03c-6.1-.92.56 6.26-8.15 8.79-8.22 2.41-20.29-11-55.11-1.56-16.65 4.51-48.39 49.89-52.37 62.59-3.99 12.69 8.72 24.7 13.08 38.12 4.35 13.42 3.75 21.92 3.75 21.92l118.48 39.28s11.72-47.93 14.57-59.73c4.35-18.11 15.24-29.15 17.27-36.7 11.43-42.52-32.26-69.84-51.49-72.73l-.02.02Z"
        style={{
          fill: '#54535e',
        }}
      />
      <path
        d="M1660.85 251.84c-8.74-.71-23.14-7.04-34.34-1.77-15 7.06-14.85 15.12-18.54 24.42-7.37 18.54-8.97 47.92-6.42 65.8 2.57 17.88 18.19 43.72 25.86 56.17 7.65 12.45 25.84 12.76 37.34 11.81s20.74 2.24 30-15.31c9.26-17.55 20.76-51.61 23.95-69.49 3.19-17.86-1.75-23.24-7.18-43.67-2.6-9.8-.12-20.33-13.94-27.09-10.28-5.05-20.45.47-36.75-.87h.02Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="m1715.86 326.39-2.31 37.69s5.1 3.19 9.57 3.83c4.46.62 7.65-.97 10.53-9.9 2.88-8.95 9.26-27.77 1.6-32.24-7.67-4.46-19.41.62-19.41.62h.02ZM1597.84 322.04l7.67 36.07s-5.1 3.19-9.57 3.83c-4.46.62-7.65-.97-10.53-9.9-2.88-8.95-9.26-27.77-1.6-32.24 7.67-4.46 14.05 2.24 14.05 2.24h-.02Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="M1652.37 339c3.68-1.02 5.32 2.86 8.71 3.07 3.59.23 3.68-6.35 12.76-2.97 4.87 1.82 19.3 6.3 26.83 9.38 6.95 2.86 11.81-2.17 13.72-12.52 1.91-10.35 2.41-16.46 2.84-23.43.43-6.97-3-23.03-3-23.03s12.04 1.42 12.47 2.05-3.19 20.36-4.8 30.82c-2.69 17.45-1.09 33.97-2.57 46.65-1.47 12.68-14.41 28.67-24.77 43.67-10.35 15-26.74 12.42-37.74 12.85s-25.37-1.63-33.19-12.19c-7.82-10.56-23.1-26.24-26.27-38.71-3.17-12.47 3.69-28.79 2.43-36.61-1.27-7.82-4.13-17.52-4.13-25.13s-6.28-21.63-6.28-21.63l12.94 1.53s-3.26 28.81 2.12 41.41c8.52 19.93 18.76 28.18 25.82 21.45 6.23-5.93 15.63-14.88 22.13-16.67h-.02Zm8.15 6.35c-6.26-.31-15.78 8.12-19.56 12.3-4.53 4.99-13.46 18.12-4.73 23.66 11.69 7.42 15.12-4.14 23.79-4.56 8.65-.42 14.76 8.71 29.78 1.63 7.75-3.66 9.26-19.84-1.58-24.59-11.93-5.22-21.8-8.15-27.71-8.45l.02.02Z"
        style={{
          fill: '#54535e',
        }}
      />
      <path
        d="M1670.18 351.23c3.94.97 10.58-.31 11.97 2.55 3.78 7.82-11.27 18.54-19.89 19.89-20.29 3.21-22.82-8.08-22.3-11.71.36-2.6 2.32-2.39 9.92-7.6 4.37-3 9.59-1.49 10.96-1.35 1.35.14 5.39-2.74 9.33-1.77l.02-.02Z"
        style={{
          fill: '#f2974a',
        }}
      />
      <path
        d="M1679.87 301.11c-.95 3.42.33 6.23 3.9 7.21 3.03.83 5.58.24 6.83-2.95 1.25-3.21-.31-6.23-3.62-7.37-3.4-1.18-6.45.69-7.11 3.1Z"
        style={{
          fill: '#272a3e',
        }}
      />
      <path
        style={{
          fill: '#272a3e',
        }}
        d="m1700.23 298.73-21.1-8.43-.52 6.23 20.31 6.69 1.31-4.49zM1679.56 275.53s13.49.42 18.5 2.46c9.64 3.94 12.28 12.17 12.28 12.17l-2.6 3.16s-3.82-6.09-10.41-8.62c-6.59-2.51-18.02-.8-18.02-.8l.24-8.38ZM1641.95 301.21c.95 3.42-.33 6.23-3.9 7.21-3.03.83-5.58.24-6.83-2.95-1.25-3.21.31-6.23 3.62-7.37 3.4-1.18 6.45.69 7.11 3.1Z"
      />
      <path
        style={{
          fill: '#272a3e',
        }}
        d="m1622.21 297.4 20.1-6.37 1.84 5.5-20.93 5.79-1.01-4.92zM1644.79 283.28l1.21-8.78s-15.43.94-20.64 2.46c-9.99 2.93-12.76 8.46-12.76 8.46l1.72 4.2s4.7-4.14 11.52-5.98c6.82-1.84 18.97-.38 18.97-.38l-.02.02Z"
      />
      <path
        d="M1713.81 423.09s13.01 4.86 33.16 16.22c14.93 8.41 56.55 13.56 75.13 36.28 28.63 35.01 17.26 82.2 7.65 152.79-15.76 115.83-46.48 106.95-46.48 106.95s8.52 91.26 12.33 119.27c3.83 28.01-3.16 54.39-3.16 54.39s-35.88 10.11-145.38 13.93-145.23-18.21-145.23-18.21 4.39-22.65 9.1-68.31c4.39-42.56 7.23-115.54 7.23-115.54s-52.2.19-78.94-12.54c-26.74-12.75-13.13-74.17 7.87-118.1 21-43.93 35.97-88.27 58.25-108.65 22.29-20.38 92.9-43.43 92.9-43.43s-3.35 17.05 33.38 22.48c57.09 8.45 82.19-37.55 82.19-37.55l-.02.03Z"
        style={{
          fill: '#75c6cf',
        }}
      />
      <path
        d="M1647.65 619.43s24.83.64 31.84 2.55c7.01 1.91 12.78 4.98 23.6 2.43s22.53 2.46 22.53 2.46 1.42 24.78-15.12 31.79c-8.29 3.5-22.98 8.06-35.17 8.48-12.68.45-23.29 2.01-23.29 2.01s-5.65-5.13-6.92-18.5c-1.27-13.37 0-26.1 2.55-31.2l-.02-.02Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="M1657.54 617.68s1.68 10.51 1.02 20.55c-.66 10.04-1.28 34.13-1.28 34.13l21.77-1.98s3.45-23.83 3.02-30.33c-.5-7.75-3.71-19.84-3.71-19.84l-20.81-2.53Z"
        style={{
          fill: '#00a39a',
        }}
      />
      <path
        d="M1536.9 618.81s-11.39 5.12-26.69 3.07c-15.3-2.03-39.44-1.35-39.44-1.35s-3.4-3.07-3.4-5.45 7.46-3.78 7.46-3.78-5.43-2.69-8.83-6.09-.68-9.52-.68-9.52l11.52 1.54s-2.41-3.52-5.76-7.51c-2.98-3.54 2.06-6.61 2.06-6.61l17.67 6.8s-2.39-3.4-3.75-6.45c-1.35-3.07 2.62-6.73 2.62-6.73s31.39 17.26 33.77 20.66 13.44 21.42 13.44 21.42Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="M1668.15 622.64c-10.2.16-15.56 7.89-15.21 15.9.36 8.32 7.39 16.01 16.49 16.39 9.33.4 16.7-6.45 16.42-15.61-.28-9.02-6.64-16.86-17.71-16.68Z"
        style={{
          fill: '#00a39a',
        }}
      />
      <path
        d="M1668.29 625.69c-8.36.1-12.82 6.4-12.57 13.01.26 6.9 6.07 13.28 13.63 13.58 7.72.29 13.75-5.39 13.48-12.94-.28-7.37-5.48-13.75-14.52-13.65h-.02Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        style={{
          fill: '#404b51',
        }}
        d="m1676.53 641.77-7.41-3.23-10.21 5.24-.61-1.01 10.86-5.67 7.82 3.59-.45 1.08z"
      />
    </svg>
  )
}

export default DadAfter
